import React, { useContext } from "react"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { ScrollSpyContext } from "@/context/scroll-spy"

const ArticleNavigation = ({ links, mobile = false }) => {
  const { t } = useTranslation()

  const { activeScrollSpyElement } = useContext(ScrollSpyContext)

  return (
    <div
      className={`article-navigation ${
        mobile
          ? "article-navigation--mobile mb-12"
          : "article-navigation--desktop"
      }`}
    >
      <h2 className={`h5 ${mobile ? "mb-3" : ""}`}>
        {t("support.navigation.go-to-section")}
      </h2>
      <ul className="article-navigation__links">
        {links.map(link => {
          return (
            <a
              key={link.id}
              className={`article-navigation__link ${
                activeScrollSpyElement === link.id
                  ? "article-navigation__link--active"
                  : ""
              }`}
              href={link.id}
            >
              {link.text}
            </a>
          )
        })}
      </ul>
    </div>
  )
}

export default ArticleNavigation
